export const opcoesSexo = [
  {id: 'MASCULINO', nome: 'Masculino'},
  {id: 'FEMININO', nome: 'Feminino'},
  {id: 'NAO_DESEJO_ESPECIFICAR', nome: 'Não desejo especificar'}
]

export const opcoesEstadoCivil = [
  { id: 'SOLTEIRO', nome: 'Solteiro(a)' },
  { id: 'CASADO', nome: 'Casado(a)' },
  { id: 'UNIAO_ESTAVEL', nome: 'União estável' },
  { id: 'DIVORCIADO', nome: 'Divorciado(a)' },
  { id: 'VIUVO', nome: 'Viúvo(a)' }
]

export const opcoesRegimeDeBens = [
  { id: 'COMUNHAO_PARCIAL_DE_BENS', nome: 'Comunhão parcial de bens' },
  { id: 'COMUNHAO_UNIVERSAL_DE_BENS', nome: 'Comunhão universal de bens' },
  { id: 'SEPARACAO_DE_BENS', nome: 'Separação de bens' },
  { id: 'PARTICIPACAO_FINAL_NOS_AQUESTOS', nome: 'Participação final nos aquestos' },
  { id: 'SEPARACAO_OBRIGATORIA_DE_BENS', nome: 'Separação obrigatória de bens' }
]



// WEBPACK FOOTER //
// ./src/libs/constants/proprietario.js